import ProcessingActivityInternalAssessmentTab from "./processingActivityInternalAssessment/ProcessingActivityInternalAssessment";
import ProcessingActivityAudits from "./processingActivityAudits/ProcessingActivityAudits";
import AuditTab from "../../../common/components/questionnaireComponents/auditTab/AuditTab";

export interface IProcessingActivityAuditTabProps {
    processingActivityId: string;
    processingActivityName: string;
    onAuditsChanged: () => void;
}

function ProcessingActivityAuditTab(props: IProcessingActivityAuditTabProps) {
    return <AuditTab externalContent={<ProcessingActivityAudits {...props} />} internalContent={<ProcessingActivityInternalAssessmentTab {...props} />} />;
}

export default ProcessingActivityAuditTab;
